import { useEffect, useState } from 'react'

/**
 * Debounce a changing value. The returned value only updates after `delay` ms
 * have passed without the source `value` changing.
 */
function useDebounceValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])
  return debouncedValue
}

export default useDebounceValue

